import React from "react";

const Loader = () => {
  return (
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  );
};

export default Loader;
